import { Team, TestIdProvider } from '@ori/testid-generator';
import { ThemeProvider } from '@ori-ui/mui';
import { Suspense } from 'react';
import type { FunctionComponent } from 'react';

import { DialogContainer } from './DialogContainer';
import { ErrorBoundary } from './ErrorBoundary';
import type { ProductInfoDialogProps } from './types';

export const ProductInfoDialog: FunctionComponent<ProductInfoDialogProps> = (props) => (
  <ErrorBoundary>
    <Suspense fallback={null}>
      <ThemeProvider
        enableCacheProvider
        cacheKey="product-info-dialog"
      >
        <TestIdProvider
          team={Team.Presentation}
          project="product-info-dialog"
        >
          <DialogContainer {...props} />
        </TestIdProvider>
      </ThemeProvider>
    </Suspense>
  </ErrorBoundary>
);
